import styled from 'styled-components'

import { Action } from '../styles/mixins'
import { StyledStatusBadge } from './bootstrap/StyledStatusBadge'

export const PendingBadge = styled(StyledStatusBadge)`
  ${Action({
    background: 'var(--badge-color-pending) !important',
    color: 'var(--font-color-light) !important',
  })}
`
